import { Button } from '@/components/ui/button'
import { useNavigate } from '@tanstack/react-router'
import { Loader2 } from 'lucide-react'
import { useEffect, useState } from 'react'

export default function AuthCallbackRoute() {
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (window.location.search.includes('error=')) {
        setError('OAuth 驗證失敗，請重新登入。')
        return
      }
      void navigate({ to: '/' })
    }, 600)

    return () => window.clearTimeout(timer)
  }, [navigate])

  return (
    <main className="grid min-h-screen place-items-center bg-slate-50 p-6">
      <div className="w-full max-w-sm rounded-lg border border-slate-200 bg-white p-8 text-center shadow-sm">
        {error ? (
          <>
            <h1 className="text-xl font-semibold text-slate-950">登入發生問題</h1>
            <p className="mt-3 text-sm text-slate-500">{error}</p>
            <Button className="mt-6 w-full" onClick={() => void navigate({ to: '/login' })}>
              返回登入
            </Button>
          </>
        ) : (
          <>
            <div className="mx-auto mb-5 grid size-12 place-items-center rounded-lg bg-indigo-50 text-indigo-600">
              <Loader2 className="size-6 animate-spin" />
            </div>
            <h1 className="text-xl font-semibold text-slate-950">正在驗證...</h1>
            <p className="mt-3 text-sm text-slate-500">正在建立安全工作區 session。</p>
          </>
        )}
      </div>
    </main>
  )
}
